module.exports = __webpack_public_path__ + "img/phone.e640e0b5.png";